
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9f7qi"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("9f7qi", function(module, exports) {

let $6bab45dce923e94f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6bab45dce923e94f$var$load("5lTVp"),
    $6bab45dce923e94f$var$load("lWNY8"),
    $6bab45dce923e94f$var$load("1F7LX"),
    $6bab45dce923e94f$var$load("jZLnv"),
    $6bab45dce923e94f$var$load("6edij"),
    $6bab45dce923e94f$var$load("hXbzh"),
    $6bab45dce923e94f$var$load("gknbb"),
    $6bab45dce923e94f$var$load("6iz6l"),
    $6bab45dce923e94f$var$load("4SCW2"),
    $6bab45dce923e94f$var$load("36QeB"),
    $6bab45dce923e94f$var$load("kQSfw"),
    $6bab45dce923e94f$var$load("8PzH3"),
    $6bab45dce923e94f$var$load("2jJ1i"),
    $6bab45dce923e94f$var$load("bd77Q"),
    $6bab45dce923e94f$var$load("hnGEQ"),
    $6bab45dce923e94f$var$load("dek7I"),
    $6bab45dce923e94f$var$load("6SWFK"),
    $6bab45dce923e94f$var$load("9aQIt"),
    $6bab45dce923e94f$var$load("5zapo"),
    $6bab45dce923e94f$var$load("3MYQs"),
    $6bab45dce923e94f$var$load("XZauT"),
    $6bab45dce923e94f$var$load("4S1SF"),
    $6bab45dce923e94f$var$load("jiFtb"),
    $6bab45dce923e94f$var$load("lm9Lt"),
    $6bab45dce923e94f$var$load("9atVd"),
    $6bab45dce923e94f$var$load("9wPDc"),
    $6bab45dce923e94f$var$load("1MWOL"),
    $6bab45dce923e94f$var$load("6fQco"),
    $6bab45dce923e94f$var$load("dYtBN"),
    $6bab45dce923e94f$var$load("kNV5Y"),
    $6bab45dce923e94f$var$load("aOY32"),
    $6bab45dce923e94f$var$load("7jSfd"),
    $6bab45dce923e94f$var$load("4HZlX"),
    $6bab45dce923e94f$var$load("6wr18"),
    $6bab45dce923e94f$var$load("kDqHr"),
    $6bab45dce923e94f$var$load("jPuvo"),
    $6bab45dce923e94f$var$load("3GuOt"),
    $6bab45dce923e94f$var$load("7EorR"),
    $6bab45dce923e94f$var$load("ffEVr"),
    $6bab45dce923e94f$var$load("7j0mT"),
    $6bab45dce923e94f$var$load("69R9L"),
    $6bab45dce923e94f$var$load("kuFG2"),
    $6bab45dce923e94f$var$load("Wowvf"),
    $6bab45dce923e94f$var$load("hhss7"),
    $6bab45dce923e94f$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("2EtBv"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("2EtBv", function(module, exports) {

let $1ee647edf5ffa18c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ee647edf5ffa18c$var$load("6wr18"),
    $1ee647edf5ffa18c$var$load("ffEVr"),
    $1ee647edf5ffa18c$var$load("a0cZb"),
    $1ee647edf5ffa18c$var$load("RXMWr"),
    $1ee647edf5ffa18c$var$load("7j0mT"),
    $1ee647edf5ffa18c$var$load("69R9L"),
    $1ee647edf5ffa18c$var$load("kuFG2"),
    $1ee647edf5ffa18c$var$load("1F7LX"),
    $1ee647edf5ffa18c$var$load("hXbzh"),
    $1ee647edf5ffa18c$var$load("hhss7"),
    $1ee647edf5ffa18c$var$load("h3ABO"),
    $1ee647edf5ffa18c$var$load("kC80R"),
    $1ee647edf5ffa18c$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("dOiia"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("dOiia", function(module, exports) {

let $a0de2247acedf598$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0de2247acedf598$var$load("6Y4f3"),
    $a0de2247acedf598$var$load("f0c8J"),
    $a0de2247acedf598$var$load("cyGuT"),
    $a0de2247acedf598$var$load("b9CA3"),
    $a0de2247acedf598$var$load("2YffH"),
    $a0de2247acedf598$var$load("ijNBa"),
    $a0de2247acedf598$var$load("hGJ7X"),
    $a0de2247acedf598$var$load("kkxT0"),
    $a0de2247acedf598$var$load("xu7ej"),
    $a0de2247acedf598$var$load("iQ4FP"),
    $a0de2247acedf598$var$load("3EXzu"),
    $a0de2247acedf598$var$load("blwYk"),
    $a0de2247acedf598$var$load("czd3n"),
    $a0de2247acedf598$var$load("c6VA1"),
    $a0de2247acedf598$var$load("2MTmD"),
    $a0de2247acedf598$var$load("2wRqX"),
    $a0de2247acedf598$var$load("50D4z"),
    $a0de2247acedf598$var$load("j9Q0e"),
    $a0de2247acedf598$var$load("71gca"),
    $a0de2247acedf598$var$load("jlCbV"),
    $a0de2247acedf598$var$load("5P3qs"),
    $a0de2247acedf598$var$load("4oXMS"),
    $a0de2247acedf598$var$load("gnDXu"),
    $a0de2247acedf598$var$load("bzyKp"),
    $a0de2247acedf598$var$load("k3yUD"),
    $a0de2247acedf598$var$load("2B2rM"),
    $a0de2247acedf598$var$load("b11Cj"),
    $a0de2247acedf598$var$load("7bkye"),
    $a0de2247acedf598$var$load("9anPW"),
    $a0de2247acedf598$var$load("fAtWn"),
    $a0de2247acedf598$var$load("iPYAE"),
    $a0de2247acedf598$var$load("6iz6l"),
    $a0de2247acedf598$var$load("4SCW2"),
    $a0de2247acedf598$var$load("kQSfw"),
    $a0de2247acedf598$var$load("8PzH3"),
    $a0de2247acedf598$var$load("2jJ1i"),
    $a0de2247acedf598$var$load("bd77Q"),
    $a0de2247acedf598$var$load("5lTVp"),
    $a0de2247acedf598$var$load("lWNY8"),
    $a0de2247acedf598$var$load("8EEwj"),
    $a0de2247acedf598$var$load("b2FtX"),
    $a0de2247acedf598$var$load("c0JsV"),
    $a0de2247acedf598$var$load("h3ABO"),
    $a0de2247acedf598$var$load("coUzl"),
    $a0de2247acedf598$var$load("5nMTY"),
    $a0de2247acedf598$var$load("7j0mT"),
    $a0de2247acedf598$var$load("69R9L"),
    $a0de2247acedf598$var$load("6wr18"),
    $a0de2247acedf598$var$load("f3xBO"),
    $a0de2247acedf598$var$load("2wyaQ"),
    $a0de2247acedf598$var$load("Wowvf"),
    $a0de2247acedf598$var$load("9DBoM"),
    $a0de2247acedf598$var$load("ffEVr"),
    $a0de2247acedf598$var$load("hhss7"),
    $a0de2247acedf598$var$load("a0cZb"),
    $a0de2247acedf598$var$load("RXMWr"),
    $a0de2247acedf598$var$load("1F7LX"),
    $a0de2247acedf598$var$load("hXbzh"),
    $a0de2247acedf598$var$load("jnVKv"),
    $a0de2247acedf598$var$load("7EorR"),
    $a0de2247acedf598$var$load("bgHzk"),
    $a0de2247acedf598$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.2b23d84a.js.map
